<template>
  <div>

    <b-row class="align-items-center mt-1">
      <b-col class="col-md-2 ml-auto text-right">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.modal-contact-id
          class="ml-auto"
          variant="primary"
        >
          <feather-icon icon="PlusIcon" size="16" />
          {{$t('add')}}
        </b-button>
      </b-col>
    </b-row>


    <b-tabs v-model="tabProvidersOrBuyers">
      <b-tab active :title="$t('providers')">
        <b-table
          v-if="!isLoading"
          id="user-table"
          class="px-1 rounded bg-light-secondary"
          :fields="fields"
          :items="GET_CONTACTS_TABLE_LIST.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
          @row-clicked="onRowClick"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(contact)="props">
            <div class="d-flex pb-50 justify-content-start m-auto w-200">
              <feather-icon class="mr-50" icon="MailIcon" size="20" />
              <span>{{ props.item.email }}</span>
            </div>

            <div class="d-flex justify-content-start m-auto w-200">
              <feather-icon class="mr-50" icon="PhoneIcon" size="20" />
              <span>{{ props.item.phone_number }}</span>
            </div>
          </template>

          <template #cell(contragent)="props">
            <div
              v-if="props.item.contact_agent && props.item.contact_agent.length"
            >
              <feather-icon class="mr-50" icon="UserIcon" size="20" />

              {{ props.item.contact_agent[0].name }}
            </div>

            <div
              v-if="props.item.contact_agent && props.item.contact_agent.length"
              class="d-flex mb-50 justify-content-center"
            >
              <feather-icon class="mr-50" icon="SmartphoneIcon" size="20" />

              <span>
                {{ props.item.contact_agent[0].phone_number }}
              </span>
            </div>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex justify-content-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                class="mt-50 mb-50"
                variant="success"
                @click="$router.push(`/contacts/detail/${props.item.id}`)"
              >
                <feather-icon icon="ChevronsRightIcon" size="15" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                class="ml-1 mt-50 mb-50"
                variant="danger"
                @click="deleteContact(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-table>


        <Pagination
          class="w-100"
          :params="filter"
          :rows="GET_CONTACTS_TABLE_LIST.count"
          @refresh="changeContactTable"
          :page="filter.page"
          :page_size="filter.page_size"
        />
      </b-tab>


      <b-tab :title="$t('buyers')">
        <b-table
          v-if="!isLoading"
          id="user-table"
          class="px-1 rounded bg-light-secondary"
          :fields="fields"
          :items="GET_CONTACTS_TABLE_LIST2.results"
          show-empty
          :tbody-tr-class="['tableRowClass']"
          small
          responsive
          :empty-text="$t('empty_text')"
          @row-clicked="onRowClick"
        >
          <template #head()="props">
            <span>{{ $t(props.label) }}</span>
          </template>

          <template #cell(contact)="props">
            <div class="d-flex pb-50 justify-content-start m-auto w-200">
              <feather-icon class="mr-50" icon="MailIcon" size="20" />
              <span>{{ props.item.email }}</span>
            </div>

            <div class="d-flex justify-content-start m-auto w-200">
              <feather-icon class="mr-50" icon="PhoneIcon" size="20" />
              <span>{{ props.item.phone_number }}</span>
            </div>
          </template>

          <template #cell(contragent)="props">
            <div
              v-if="props.item.contact_agent && props.item.contact_agent.length"
            >
              <feather-icon class="mr-50" icon="UserIcon" size="20" />
              {{ props.item.contact_agent[0].name }}
            </div>


            <div
              v-if="props.item.contact_agent && props.item.contact_agent.length"
              class="d-flex mb-50 justify-content-center"
            >
              <feather-icon class="mr-50" icon="SmartphoneIcon" size="20" />
              <span>
                {{ props.item.contact_agent[0].phone_number }}
              </span>
            </div>
          </template>

          <template #cell(actions)="props">
            <div class="d-flex justify-content-center">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                class="mt-50 mb-50"
                variant="success"
                @click="$router.push(`/contacts/detail/${props.item.id}`)"
              >
                <feather-icon icon="ChevronsRightIcon" size="15" />
              </b-button>

              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                size="sm"
                class="ml-1 mt-50 mb-50"
                variant="danger"
                @click="deleteBuyerContact(props)"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-table>


        <Pagination
          class="w-100"
          :params="filter2"
          :rows="GET_CONTACTS_TABLE_LIST2.count"
          @refresh="changeBuyerContactTable"
          :page="filter2.page"
          :page_size="filter2.page_size"
        />
      </b-tab>
    </b-tabs>



   
    

    <addEditModal @save="FETCH_ALL_CONTACTS_LIST" />
  </div>
</template>

<script>
import { BButton, BCol, BRow, BTable, BCard, BTabs, BTab,  } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { mapActions, mapGetters } from "vuex";
import Pagination from "@/components/Pagination.vue";
import addEditModal from "./addEditModal.vue";
import areYouSure from "@/mixins/areYouSure";

export default {
  components: {
    BButton,
    BCol,
    BRow,
    BCard,
    BTable,
    BTabs,
    BTab,

    Pagination,
    addEditModal,
  },
  directives: {
    Ripple,
  },
  mixins: [areYouSure],
  data() {
    return {
      isLoading: false,
      filter: {
        page: 1,
        page_size: 10,
      },
      filter2: {
        page: 1,
        page_size: 10,
      },
      fields: [
        {
          label: "№",
          key: "id",
          thClass: "tableHeadClass",
        },
        {
          label: "company",
          key: "company_name",
          thClass: "tableHeadClass",
        },
        {
          label: "contact.contacts",
          key: "contact",
          thClass: "tableHeadClass",
        },
        {
          label: "contact.kontragent",
          key: "contragent",
          thClass: "tableHeadClass",
        },
        {
          label: "actions",
          key: "actions",
          thClass: "tableHeadClass",
        },
      ],
      tabSelected: false,
    };
  },
  computed: {
    ...mapGetters("contacts", ["GET_CONTACTS_TABLE_LIST", "GET_CONTACTS_TABLE_LIST2"]),

    tabProvidersOrBuyers: {
      get: function () {
        return this.$store.state.contacts.tabProvidersOrBuyers;
      },
      set: function (newValue) {
        this.$store.commit("contacts/SET_TAB_PROVIDER_OR_BUYER", newValue);
      },
    },

  },
  async mounted() {
    this.isLoading = true;

    let page = this.$route.query.page
    let page_size = this.$route.query.page_size

    await this.FETCH_ALL_CONTACTS_LIST({ page: page ? page : 1, page_size: page_size ? page_size: 10, type: "provider" });
    await this.FETCH_ALL_CONTACTS_LIST2({ page: page ? page : 1, page_size: page_size ? page_size: 10, type: "buyer" }); 
    
    if(page){
      this.filter.page = page
      this.filter2.page = page
    }
    if(page_size){
      this.filter.page_size = page_size
      this.filter2.page_size = page_size
    }

    this.isLoading = false;
  },

  methods: {
    ...mapActions("contacts", ["FETCH_ALL_CONTACTS_LIST", "FETCH_ALL_CONTACTS_LIST2", "DELETE_CONTACT"]),

    onRowClick(params) {
      this.$router.push(`/contacts/detail/${params.id}`);
    },

    async changeContactTable() {
      this.isLoading = true;

      this.GET_CONTACTS_TABLE_LIST = await this.FETCH_ALL_CONTACTS_LIST({...this.filter, type: "provider"});
      this.$router.replace({ path: "/contacts", query: { page: this.filter.page, page_size: this.filter.page_size } });

      this.isLoading = false;
    },
    
    async changeBuyerContactTable() {
      this.isLoading = true;

      this.GET_CONTACTS_TABLE_LIST2 = await this.FETCH_ALL_CONTACTS_LIST({...this.filter2, type: "buyer"});
      this.$router.replace({ path: "/contacts", query: { page: this.filter2.page, page_size: this.filter2.page_size } });

      this.isLoading = false;
    },


    async deleteContact(props) {
      await this.$_showAreYouSureModal().then( async (val) => {
        if (val) {
          await this.DELETE_CONTACT(props.item.id)
            .then( async () => {
              this.GET_CONTACTS_TABLE_LIST = await this.FETCH_ALL_CONTACTS_LIST({...this.filter, type: "provider"});
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },


    async deleteBuyerContact(props) {
      await this.$_showAreYouSureModal().then( async (val) => {
        if (val) {
          await this.DELETE_CONTACT(props.item.id)
            .then( async () => {
              this.GET_CONTACTS_TABLE_LIST2 = await this.FETCH_ALL_CONTACTS_LIST({...this.filter2, type: "buyer"});
              this.$_okToast();
            })
            .catch((err) => {
              this.$_errToast(err);
            });
        }
      });
    },




  },
};
</script>

<style lang="scss">
#user-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}

#user-table .tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);

  td {
    border-top: 0;
    padding: 20px !important;

    &:first-child {
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

#user-table .tableRowClass:hover {
  transform: translateY(0);
  cursor: pointer;
}

#user-table .tableHeadClass {
  background: none !important;
  border: none !important;
}

#user-table .tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.tableHeadClass {
  text-align: center;
  padding-left: 0 !important;
}

.w-200 {
  width: 215px !important;
}
</style>
